module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hK9Sn"))).then(() => parcelRequire('fThBo'));